import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _8ae52cb6 = () => interopDefault(import('../pages/check-redirect.vue' /* webpackChunkName: "pages/check-redirect" */))
const _4832abac = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _3ec90b11 = () => interopDefault(import('../pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _09255775 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _505a24b5 = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _16d3db9a = () => interopDefault(import('../pages/regist.vue' /* webpackChunkName: "pages/regist" */))
const _0ecd9147 = () => interopDefault(import('../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _228fcbe8 = () => interopDefault(import('../pages/register-score.vue' /* webpackChunkName: "pages/register-score" */))
const _30b867fd = () => interopDefault(import('../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _4cd057b2 = () => interopDefault(import('../pages/user/index.vue' /* webpackChunkName: "pages/user/index" */))
const _0a3bc736 = () => interopDefault(import('../pages/measurement/user/index.vue' /* webpackChunkName: "pages/measurement/user/index" */))
const _4671e3d8 = () => interopDefault(import('../pages/setting/department/index.vue' /* webpackChunkName: "pages/setting/department/index" */))
const _727478aa = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _796b1900 = () => interopDefault(import('../pages/user/new.vue' /* webpackChunkName: "pages/user/new" */))
const _37e65db4 = () => interopDefault(import('../pages/setting/department/new.vue' /* webpackChunkName: "pages/setting/department/new" */))
const _32f27278 = () => interopDefault(import('../pages/setting/tag/new.vue' /* webpackChunkName: "pages/setting/tag/new" */))
const _5ca5f40d = () => interopDefault(import('../pages/measurement/user/_id.vue' /* webpackChunkName: "pages/measurement/user/_id" */))
const _5f520780 = () => interopDefault(import('../pages/setting/department/_id.vue' /* webpackChunkName: "pages/setting/department/_id" */))
const _1f3c9d92 = () => interopDefault(import('../pages/setting/tag/_id.vue' /* webpackChunkName: "pages/setting/tag/_id" */))
const _a0d6c2cc = () => interopDefault(import('../pages/user/_id.vue' /* webpackChunkName: "pages/user/_id" */))
const _3f7db45e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/check-redirect",
    component: _8ae52cb6,
    name: "check-redirect"
  }, {
    path: "/contact",
    component: _4832abac,
    name: "contact"
  }, {
    path: "/forgot-password",
    component: _3ec90b11,
    name: "forgot-password"
  }, {
    path: "/login",
    component: _09255775,
    name: "login"
  }, {
    path: "/profile",
    component: _505a24b5,
    name: "profile"
  }, {
    path: "/regist",
    component: _16d3db9a,
    name: "regist"
  }, {
    path: "/register",
    component: _0ecd9147,
    name: "register"
  }, {
    path: "/register-score",
    component: _228fcbe8,
    name: "register-score"
  }, {
    path: "/reset-password",
    component: _30b867fd,
    name: "reset-password"
  }, {
    path: "/user",
    component: _4cd057b2,
    name: "user"
  }, {
    path: "/measurement/user",
    component: _0a3bc736,
    name: "measurement-user"
  }, {
    path: "/setting/department",
    component: _4671e3d8,
    name: "setting-department"
  }, {
    path: "/setting/tag",
    component: _727478aa,
    name: "setting-tag"
  }, {
    path: "/user/new",
    component: _796b1900,
    name: "user-new"
  }, {
    path: "/setting/department/new",
    component: _37e65db4,
    name: "setting-department-new"
  }, {
    path: "/setting/tag/new",
    component: _32f27278,
    name: "setting-tag-new"
  }, {
    path: "/measurement/user/:id",
    component: _5ca5f40d,
    name: "measurement-user-id"
  }, {
    path: "/setting/department/:id",
    component: _5f520780,
    name: "setting-department-id"
  }, {
    path: "/setting/tag/:id",
    component: _1f3c9d92,
    name: "setting-tag-id"
  }, {
    path: "/user/:id",
    component: _a0d6c2cc,
    name: "user-id"
  }, {
    path: "/",
    component: _3f7db45e,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
